import { Component, Input, OnInit } from '@angular/core';
import { ContentElement, ContentEnum, GridCell, SectionData } from '../../models/sections-model';

@Component({
  selector: 'ngx-blog-renderer',
  templateUrl: './blog-renderer.component.html',
  styleUrls: ['./blog-renderer.component.scss']
})
export class BlogRendererComponent implements OnInit {
  @Input()data:SectionData;
  @Input() edit:boolean = true;
  @Input() title:string;
  gridCells:GridCell[];
  blogHeader:GridCell;
  titleContent:ContentElement;
  authorContent:ContentElement;
  dateContent:ContentElement;

  headerClasses = ["h1","h2","h3","h4","h5","h6",];
  fontSizeClasses = [ "fnt-size-tiny",
  "fnt-size-small",
  "fnt-size-medium",
  "fnt-size-standard",
  "fnt-size-standard-large",
  "fnt-size-standard-larger",
  "fnt-size-large",
  "fnt-size-larger",
  "fnt-size-very-large",
  "fnt-size-gigantic",
  "fnt-size-enormous"]
   
  
  constructor() { }

  ngOnInit(): void {
    console.log(this.data)
    this.gridCells = this.data.gridOptions.gridCells;
    //console.log(this.gridCells);

    //Get the header info
    this.blogHeader = this.gridCells.find(cell => cell.contentEnum == ContentEnum["Blog Header"]);
    
  }
  onUpdateContent(e){

  }

  addDefaultClasses(contentElement:ContentElement){
    switch (contentElement.contentElementEnum) {
      case "header":
        if(contentElement.classes == undefined){
          contentElement.classes = [];
          contentElement["classes"].push("h4");
        }else if(contentElement.classes.length == 0){
          contentElement["classes"].push("h4");
        }else if(contentElement.classes.length > 0){
          const hasHeader = this.headerClasses.some(v => contentElement.classes.includes(v));
          if(!hasHeader){
            contentElement["classes"].push("h4");
          }
        }
                
        break;
      case "text":
        if(contentElement.classes == undefined){
          contentElement.classes = [];
          contentElement["classes"].push("fnt-size-medium");
        }else if(contentElement.classes.length == 0){
          contentElement["classes"].push("fnt-size-medium");
        }else if(contentElement.classes.length > 0){
          const hasHeader = this.headerClasses.some(v => contentElement.classes.includes(v));
          if(!hasHeader){
            contentElement["classes"].push("fnt-size-medium");
          }
        }
          
        break;
      case "date":
        if(contentElement.classes == undefined){
          contentElement.classes = [];
          contentElement["classes"].push("fnt-size-medium");
        }else if(contentElement.classes.length == 0){
          contentElement["classes"].push("fnt-size-medium");
        }else if(contentElement.classes.length > 0){
          const hasHeader = this.headerClasses.some(v => contentElement.classes.includes(v));
          if(!hasHeader){
            contentElement["classes"].push("fnt-size-medium");
          }
        }
        break;
    
      default:
        break;
    }

  }

}

/* this.fontSizes.forEach(fontSize => {
  if(contentElement.classes.includes(fontSize.class)){
    let itmIndx = contentElement.classes.indexOf(fontSize.class);
    if(itmIndx !== -1){
      console.log("Removing classes")
      contentElement.classes.splice(itmIndx,1);
    }
  }
})
contentElement.classes.push(e.class); */
